__turbopack_context__.v({
  "actionButton": "_8VoYTG_actionButton",
  "actionCalenderTile": "_8VoYTG_actionCalenderTile",
  "blue": "_8VoYTG_blue",
  "darkGreen": "_8VoYTG_darkGreen",
  "dayNumber": "_8VoYTG_dayNumber",
  "expired": "_8VoYTG_expired",
  "expiredBlendOverlay": "_8VoYTG_expiredBlendOverlay",
  "expiredBlurOverlay": "_8VoYTG_expiredBlurOverlay",
  "expiredText": "_8VoYTG_expiredText",
  "icon": "_8VoYTG_icon",
  "iconVariant": "_8VoYTG_iconVariant",
  "image": "_8VoYTG_image",
  "imageOverlay": "_8VoYTG_imageOverlay",
  "lightGreen": "_8VoYTG_lightGreen",
  "magenta": "_8VoYTG_magenta",
  "modalContent": "_8VoYTG_modalContent",
  "orange": "_8VoYTG_orange",
  "overlayOutline": "_8VoYTG_overlayOutline",
  "photo": "_8VoYTG_photo",
  "photoDarkVariant": "_8VoYTG_photoDarkVariant",
  "photoLightVariant": "_8VoYTG_photoLightVariant",
  "red": "_8VoYTG_red",
  "standardGreen": "_8VoYTG_standardGreen",
  "tileModal": "_8VoYTG_tileModal",
});
